import { QueryCellInfoEventArgs } from "@syncfusion/ej2-angular-grids";
import { Tooltip } from "@syncfusion/ej2-angular-popups";

export class TooltipHelper {

  public static createMultilineGridTooltip(args: QueryCellInfoEventArgs, onlyForFieldNames: string[] = null, opensOn = null) {
    if (onlyForFieldNames && onlyForFieldNames.indexOf(args.column.field) < 0) {
      return;
    }
    let content = args.data[args.column.field]?.toString();
    if (content) {
      content = content.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }
    // create tooltip object and add it to args.cell
    new Tooltip({
      content: content,
      opensOn: opensOn ?? 'Auto'
    }, args.cell as HTMLTableCellElement);
  }

  public static isJsonMessage(data: string): boolean {
    return (data.indexOf("[{") >= 0 && data.indexOf("}]") > 0);
  }

  public static extractJsonMessage(data: string, onlyContent: boolean, maxCharForOnlyContent: number): string {
    if (data) {
      // the message can contain json string. we try to extract the first json object and produce the table for tooltip
      if (TooltipHelper.isJsonMessage(data)) {
        var jsonData = data.substring(
          data.indexOf("[{"),
          data.indexOf("}]") + 2);
        try {
          let obj = JSON.parse(jsonData);
          if (obj) {
            if (onlyContent) { // only the messages are required. No table structure,
              let leftPart = data.substring(0, data.indexOf("[{"));
              return this.buildMessageWithCharLimit(leftPart, obj, maxCharForOnlyContent);
            }
            else {
              return this.getTableData(obj); // tabular data of the json message
            }
          }
        } catch (e) { }
      }
      return data.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }
    return '';
  }


  private static buildMessageWithCharLimit(leftPart: string, jsonObj: any, maxChar: number): string {
    // 1) Normalize and clean trailing newlines/whitespace from leftPart
    const cleanLeft = (leftPart ?? '')
      // convert CRLF/CR/LF to spaces so we don’t produce empty segments
      .replace(/(?:\r\n|\r|\n)+/g, ' ')
      // collapse multiple spaces
      .replace(/\s{2,}/g, ' ')
      // trim leftover whitespace
      .trim();

    // 2) Build rightPart from Messages
    const rightPart = Array.isArray(jsonObj)
      ? jsonObj.map(l => l?.Message).filter(Boolean).join(', ')
      : '';

    // 3) Join only the non-empty parts, avoiding a leading/trailing comma
    const combined = [cleanLeft, rightPart].filter(s => s && s.trim().length > 0).join(', ');

    // 4) Respect maxChar (keep your original behavior)
    if (maxChar > 0) {
      // If the original intent was: when leftPart itself exceeds max, return it,
      // you can keep this rule:
      if (cleanLeft.length > maxChar) return cleanLeft;
      return combined.substring(0, maxChar);
    }
    return combined;
  }


  private static getTableData(jsonData): string {
    const excludeProperties = ['Id', 'Status'];
    let table = '<table border="1">';

    // Create table header
    table += '<thead><tr>';
    const keys = Object.keys(jsonData[0]).filter(key => key !== 'Indicator' && !excludeProperties.includes(key));
    keys.forEach(key => {
      table += `<th>${key}</th>`;
    });
    table += '</tr></thead>';

    // Create table rows
    table += '<tbody>';
    jsonData.forEach(item => {
      table += '<tr>';
      keys.forEach((key, index) => {
        let value = item[key];
        if (index === 0 && item.Indicator) {
          value = `${value} (${item.Indicator})`;
        }
        table += `<td>${value}</td>`;
      });
      table += '</tr>';
    });
    table += '</tbody>';

    table += '</table>';
    return table;
  }
}

